export default __webpack_public_path__ + "static/media/raspy.f3493e47.png";